import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    padding: 1rem 0;
    border-bottom: 1px solid #e0e0e0;
`;
